const POSTER_IN_SET = 136
const FLYER_IN_SET = 137

export const PRODUCT_TYPES = {
    POSTER_IN_SET,
    FLYER_IN_SET,
    PRODUCTS_IN_SET: [POSTER_IN_SET, FLYER_IN_SET]
} as const
